const defaultOfferTypes = {
  '': 'Prix catalogue',
  off_season: 'Offre du moment',
}

export default defaultOfferTypes
